import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { Z_INDEX } from '@/constants/z-index';
import { flexColumn, openingEffect } from '@/styles/common';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  z-index: ${Z_INDEX.DROPDOWN};
`;

export const ToggleButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: ${Z_INDEX.DROPDOWN};
  padding: 5px 15px;
  background-color: ${({ $isOpen }) =>
    $isOpen ? 'var(--bg-secondary)' : 'transparent'};
  border: 1px solid var(--border-main);
  border-radius: 28px;
  cursor: pointer;
  color: var(--textAndLabels-main);
  transition: background 0.3s ease;

  &:hover {
    background: var(--bg-secondary);
  }
`;

export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 300px;
  ${flexColumn};
  gap: 6px;
  background: var(--bg-main);
  border-radius: 28px;
  padding: 20px 10px;
  z-index: ${Z_INDEX.DROPDOWN};
  ${openingEffect()}
`;

export const EmailText = styled(Typography).attrs({ variant: 'h5' })`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DropdownHeader = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 5px 10px;
  background: none;
  border: none;
  text-align: left;
  color: var(--textAndLabels-main);
  cursor: pointer;
  overflow: hidden;

  &:hover ${EmailText} {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
  }
`;

export const IconBox = styled.span`
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const DropdownItem = styled.button<{ $isDanger?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 10px;
  background: none;
  border: none;
  border-radius: 20px;
  text-align: left;
  color: var(--textAndLabels-main);
  cursor: pointer;
  transition:
    background 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: ${({ $isDanger }) =>
      $isDanger ? 'var(--system-redHover)' : 'var(--bg-secondary)'};
    color: ${({ $isDanger }) =>
      $isDanger ? 'var(--system-red)' : 'var(--textAndLabels-main)'};
  }
`;

export const DividerWrapper = styled.div`
  margin: 14px 0;
  padding: 0 10px;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--border-secondary);
`;

export const Arrow = styled.div<{ $isOpen: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
`;
